import { utc } from 'moment';
import { ProfileMapper } from '../../../common/mappers/ProfileMapper';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { Report, ReportStatus } from '../models/valueObjects/Report';
import { TraceMapper } from './TraceMapper';

export class ReportMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();
  readonly traceMapper = new TraceMapper();
  readonly profileMapper = new ProfileMapper();

  mapGQLModel(data: any): Report {
    const id = this.gqlIdEncoder.decode(data.id);
    const trace = data.trace ? this.traceMapper.mapGQLModel(data.trace) : null;
    const profile = data.profile ? this.profileMapper.mapGQLModel(data.profile) : null;
    const status = data.__typename === 'ReportDone' ? ReportStatus.DONE : data.__typename === 'ReportPending' ? ReportStatus.PENDING : ReportStatus.FAILED;

    return new Report(id, data.name, status, utc(data.createdAt), trace, profile);
  }
}
